import { MaterialDefinitionType } from 'commons-app/types/material-definition.type';
import { QcLevel, RangeMode, ResultType } from '../material-definition.vm';

export const DEFAULT_LOT_NUMBER_MAX_LENGTH = 8;
export const LOT_NUMBER_MAX_LENGTH_MIN = 1;
export const LOT_NUMBER_MAX_LENGTH_MAX = 100;

export const DEFAULT_RESULT_TYPE: ResultType = 'QUANTITATIVE';
export const DEFAULT_RANGE_MODE: RangeMode = 'MIN_MAX';

export const MAX_QC_LEVELS_PER_TEST = 10;

export const rangeModeForResultType = (resultType: ResultType, current?: RangeMode | null): RangeMode | null =>
    resultType === 'QUANTITATIVE' ? (current ?? DEFAULT_RANGE_MODE) : null;

export interface QcLevelFormItem extends QcLevel {
    clientKey?: string;
}

export type QcLevelNumericField = 'defaultMin' | 'defaultMax' | 'defaultTarget' | 'defaultDeviationPercent';

export type QcLevelEditableField = 'name' | QcLevelNumericField | 'defaultTargetValues';

const trailingNumber = (name: string): number => {
    const match = /(\d+)\s*$/.exec(name.trim());
    return match ? Number(match[1]) : 0;
};

export const nextLevelNumber = (levels: QcLevelFormItem[]): number =>
    levels.reduce((highest, level) => Math.max(highest, trailingNumber(level.name)), 0) + 1;

export interface TestConfigFormItem {
    clientKey: string;
    testId: string;
    resultType: ResultType;
    rangeMode?: RangeMode | null;
    qcLevels?: QcLevelFormItem[];
    possibleValues?: string;
}

export interface MaterialDefinitionFormState {
    name: string;
    longName: string;
    provider: string;
    type: MaterialDefinitionType | '';
    deviceTypeId: string;
    testConfigs: TestConfigFormItem[];
    lotNumberMaxLength: number | null;
    allowAlphanumericLotNumbers: boolean;
}

export const INITIAL_FORM_STATE: MaterialDefinitionFormState = {
    name: '',
    longName: '',
    provider: '',
    type: '',
    deviceTypeId: '',
    testConfigs: [],
    lotNumberMaxLength: DEFAULT_LOT_NUMBER_MAX_LENGTH,
    allowAlphanumericLotNumbers: false,
};
